// @module SuiteDB.SDBLocations.SDBContactForm
define("SuiteDB.SDBLocations.SDBContactForm.View", [
  "suitedb_sdblocations_sdbcontactform.tpl",
  "SuiteDB.SDBLocations.SDBContactForm.Model",
  "Backbone",
  "SDB.SDBLocations.Model",
  "CCA.Recaptcha.Manager",
], function (
  suitedb_sdblocations_sdbcontactform_tpl,
  SDBContactFormModel,
  Backbone,
  SDBLocationModel,
  RecaptchaManager
) {
  "use strict";

  // @class SuiteDB.SDBLocations.SDBContactForm.View @extends Backbone.View
  return Backbone.View.extend({
    template: suitedb_sdblocations_sdbcontactform_tpl,

    initialize: function initialize(options) {
      var self = this;
      self.SUCCESS_MESSAGE = "Message sent successfully";
      this.options = options;
      this.model = SDBLocationModel.getInstance();
      this.formModel = new SDBContactFormModel();
      var recaptchaSiteKey =
        (SC.CONFIGURATION.ccaReCaptcha &&
          SC.CONFIGURATION.ccaReCaptcha.siteKey) ||
        "";
      this.recaptcha = new RecaptchaManager({
        containerSelector: "#contact-form-recaptcha",
        siteKey: recaptchaSiteKey,
      });
      this._isSubmitting = false;

      this.shoppingExperience = this.model.getShoppingExperience();

      this.attributes = {
        id: "SDBContactFormViewId",
        class: "sdb-contactform-view",
      };

      var selectLocation = function selectLocation(location) {
        if (location)
          var selectedIndex = _.findIndex(self.locations, function (value) {
            return value.name == location;
          });
        for (var i = 0; i < self.locations.length; i++) {
          if (self.locations[i].selected) delete self.locations[i].selected;
        }
        if (selectedIndex && selectedIndex != -1) {
          self.locations[selectedIndex].selected = true;
          self.locationSelected = true;
        } else {
          self.locationSelected = false;
        }
      };

      //load locations
      var locations = this.model.getLocations();
      this.locations = _.map(
        locations,
        function (value) {
          return { name: value.name, value: value.name };
        },
        {}
      );

      //load selected location
      var selectedLocation = this.model.getSelectedLocation();
      if (selectedLocation) selectLocation(selectedLocation.name);

      this.model.on("change:location", function () {
        if (self.model.getShoppingExperience() !== "online") {
          var select = document.querySelector("#select-contact");
          var selectedLocation = self.model.getSelectedLocation();
          select.value = selectedLocation.name;

          var label = select.parentElement.querySelector(".select-label");
          label.classList.add("label-select");

          selectLocation(selectedLocation.name);
        }
      });
      this.model.on("change:shoppingExperience", function () {
        if (self.model.getShoppingExperience() === "online") {
          selectLocation();
        }
      });
      this.render = _.wrap(this.render, function (fn) {
        fn.apply(this, _.toArray(arguments).slice(1));
        setTimeout(function () {
          var change = !self.model.get("loadContactMap");
          self.model.set("loadContactMap", change);

          var inputs = $(".form-div-parent")[0].querySelectorAll(
            "input:not([required])"
          );
          for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            if (input.value == "") input.className = "invalid-input";
          }

          // Re-bind reCAPTCHA manager to the new DOM
          self.recaptcha && self.recaptcha.afterRender(self.$el);
        }, 0);
      });
    },

    events: {
      "change #select-contact": "changeSelect",
      'click [data-action="submit-form"]': "submitForm",
      "change input:not([required])": "validateInput",
    },

    bindings: {},

    childViews: {},
    submitForm: function submitForm(e) {
      var el = $(e.currentTarget);
      var form = el.parents("form");
      e.preventDefault();
      if (this._isSubmitting) {
        return;
      }
      if (!form[0].reportValidity() || !this.recaptcha) {
        return;
      }
      this._isSubmitting = true;
      el.prop("disabled", true);
      // Execute reCAPTCHA via manager; on success continue submission
      var selfView = this;
      this.recaptcha
        .executeAndGetToken()
        .then(function (token) {
          selfView._onRecaptchaSuccess(token);
        })
        .catch(function () {
          selfView._onRecaptchaError();
        });
    },
    validateInput: function validateInput(e) {
      if (e.target.value != "") e.target.className = "";
      else e.target.className = "invalid-input";
    },

    _onRecaptchaSuccess: function _onRecaptchaSuccess(token) {
      var form = this.$("form");
      var formValues = form.serializeObject();
      formValues["g-recaptcha-response"] = token;
      var self = this;
      this.formModel
        .fetch({
          data: {
            formValues: JSON.stringify(formValues),
          },
          async: false,
        })
        .done(function (res) {
          if (res && res.result == "success") {
            self.message = self.SUCCESS_MESSAGE;
          } else {
            self.message = "An error has occurred, please try again later";
          }
          // Re-render to refresh message and reCAPTCHA widget
          self._finalizeSubmit();
        })
        .fail(function () {
          self.message = "An error has occurred, please try again later";
          self._finalizeSubmit();
        });
    },

    _onRecaptchaError: function _onRecaptchaError() {
      this._finalizeSubmit();
    },

    _finalizeSubmit: function _finalizeSubmit() {
      // Enable button and re-render view to refresh badge/widget and show message
      this._isSubmitting = false;
      this.$('[data-action="submit-form"]').prop("disabled", false);
      this.render();

      // redirect to thank you page
      if (this.message === this.SUCCESS_MESSAGE) {
        Backbone.history.navigate("/contact-thank-you", { trigger: true });
      }
    },

    changeSelect: function changeSelect(e) {
      var select = e.target;
      var label = select.parentElement.querySelector(".select-label");
      if (select.value !== "") label.classList.add("label-select");
      else label.classList.remove("label-select");
    },

    getContext: function getContext() {
      //load selected vehicle
      var cookies = document.cookie.split(";");
      if (cookies && cookies.length > 1) {
        var selectedvehicle = cookies.find(function (cookie) {
          return cookie.indexOf("vehicle=") !== -1;
        });
      }
      if (selectedvehicle) {
        var vehicle = JSON.parse(selectedvehicle.split("=")[1].trim());
        this.selectedVehicle =
          vehicle.year + " " + vehicle.make + " " + vehicle.model;
      } else {
        delete this.selectedVehicle;
      }

      return {
        locations: this.locations,
        locationSelected: this.locationSelected,
        selectedVehicle: this.selectedVehicle,
        message: this.message,
      };
    },
  });
});
